import { boardEl, complimentAnimationEl, complimentImageEl } from "./elements";
import { gameState, levelDef } from "./game/gameState";

const COMPLIMENT_IMG_IDS = [
  "cattastic",
  "clawvermove",
  "goodjob",
  "greatcatch",
  "greatmove",
  "meowgnificent",
  "purrettygood",
  "purrfection",
  "purrfectmove",
  "sweet",
  "meowtastic",
  "purrfect",
  "welldone",
];

const SHORT_COMPLIMENT_IMG_IDS = [
  "goodjob",
  "greatcatch",
  "greatmove",
  "sweet",
  "purrfect",
  "welldone",
];

const BOOSTER_COMPLIMENT_IMG_IDS = [
  "cattastic",
  "clawvermove",
  "greatmove",
  "meowgnificent",
  "purrettygood",
  "purrfection",
  "purrfectmove",
  "sweet",
  "meowtastic",
  "purrfect",
];

let i_ = 0;
export const COMPLIMENT_TYPE = {
  ALL: i_++,
  SHORT: i_++,
  BOOSTER: i_++,
};

const COMPLIMENT_TYPE_MAP = {
  [COMPLIMENT_TYPE.ALL]: COMPLIMENT_IMG_IDS,
  [COMPLIMENT_TYPE.SHORT]: SHORT_COMPLIMENT_IMG_IDS,
  [COMPLIMENT_TYPE.BOOSTER]: BOOSTER_COMPLIMENT_IMG_IDS,
};

let gIsActive = false;
let gPrevIdx = null;

export function launchComplimentAnimation({
  duration = 2200,
  complimentType = COMPLIMENT_TYPE.ALL,
} = {}) {
  if (gIsActive) return;
  gIsActive = true;
  return new Promise((resolve) => {
    // Read operation
    const avgY = gameState.cats.getAvgY();
    const { left, width } = boardEl.getBoundingClientRect();

    // Write operations
    const showOnTop = avgY >= (levelDef.fieldSize - 1) / 2;
    complimentAnimationEl.style.top = showOnTop ? "0" : null;
    complimentAnimationEl.style.bottom = showOnTop ? null : "0";

    complimentAnimationEl.style.left = `${left + width / 2}px`;

    const compliment_ids = COMPLIMENT_TYPE_MAP[complimentType];
    complimentAnimationEl.style.animation = `zoom ${duration}ms ease`;
    complimentImageEl.style.animation = `appear3 ${duration}ms ease`;
    complimentAnimationEl.style.display = "initial";

    let randomIndex = Math.floor(Math.random() * compliment_ids.length);
    if (randomIndex === gPrevIdx)
      randomIndex = (randomIndex + 1) % compliment_ids.length;
    gPrevIdx = randomIndex;

    complimentImageEl.src = `./img/compliments/${compliment_ids[randomIndex]}.png`;

    setTimeout(finishCompliment, duration, resolve);
  });
}

function finishCompliment(resolve) {
  complimentAnimationEl.style.display = "none";
  gIsActive = false;
  resolve();
}

if (__DEV__) window.launchComplimentAnimation = launchComplimentAnimation;
